import { combineReducers } from 'redux';
import { surveyReducer } from './survey';
import { companyReducer } from './company';

export const jobMappingReducer = combineReducers({
  company: companyReducer,
  survey: surveyReducer,
});
